import * as yup from "yup";

export const yupStringRequired = yup
  .string()
  .nullable()
  .required("This is a required field and cannot be blank.");
